import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import CategoryWrapper from '../components/Category/CategoryWrapper';
import CategoryHeader from '../components/Category/CategoryHeader';
import CategoryBody from '../components/Category/CategoryBody';
import ProductHorizontal from '../components/ProductHorizontal';
import { facebookUriShare, hostName, twitterUriShare } from '../environment';
import { useDispatch, useSelector } from 'react-redux';
import { globalState$, isLoadingDetailState$, postDetailState$, postsRelatedState$ } from '../redux/selectors';
import { getPostDetail } from '../redux/actions';
import AffiliateLinks from '../components/AffiliateLinks';
import { postsLatestState$ } from '../redux/selectors';
import PostNotFound from '../components/PostNotFound';
import { convertToVNDate } from '../helpers';
import { SITE_TITLE } from '../constant';

export default function PostDetail({ location }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const postDetail = useSelector(postDetailState$);
  const isLoading = useSelector(isLoadingDetailState$);
  const posts = useSelector(postsLatestState$);
  const relatedPosts = useSelector(postsRelatedState$);
  const [iconStyle, setIconStyle] = React.useState('fa fa-heart');
  const { pathname } = location;
  let isUnlike = useRef(true);
  const { authorLogo } = useSelector(globalState$);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    document.title = postDetail.title || SITE_TITLE;
    return () => {
      document.title = SITE_TITLE;
    };
  }, [id, pathname, postDetail.title]);

  useLayoutEffect(() => {
    dispatch(getPostDetail.sendPostDetailRequest(id));
  }, [dispatch, id]);

  const handleClickLike = () => {
    isUnlike.current = !isUnlike.current;
    if (isUnlike.current) {
      setIconStyle('fa fa-heart');
    } else {
      setIconStyle('fa fa-heart text-danger');
    }
  };

  if (!isLoading && Object.keys(postDetail).length === 0) {
    return <PostNotFound />;
  }

  return !isLoading && Object.keys(postDetail).length !== 0 && (
    <>
      <div className="row justify-content-center" style={{ width: '99%', margin: 'auto' }}>
        <div className="col-lg-8 mt-3 border rounded">
          <div className="p-breakcrumb">
            <div className="p-breakcrumb-item">{postDetail.category}</div>
            &nbsp;<i className="fa fa-angle-double-right fw-bold" aria-hidden="true"></i>&nbsp;
            <div className="p-breakcrumb-item">{postDetail.type}</div>
            <span className="icon-likes">
              {/* {postDetail.likeCount}&nbsp; */}
              <i className={iconStyle} style={{ cursor: 'pointer' }}
                onClick={handleClickLike}></i>
            </span>
          </div>
          <div className="d-flex flex-row align-items-center pt-3">
            <div>
              <img src={authorLogo} alt="Author" width="50" height="50" className="rounded-circle" />
            </div>
            <div className="ms-2">
              <div className="fw-bold" style={{ fontSize: '17px' }}>{postDetail.author}</div>
              <div style={{
                fontSize: '13px',
                paddingBottom: '5px',
                color: '#999',
                lineHeight: '13px'
              }}>{convertToVNDate(postDetail.createdAt)}</div>
            </div>
          </div>
          <h1 className="post-title">{postDetail.title}</h1>
          <div className="text-center">
            <img src={postDetail.image} alt="Feature" height="280" />
          </div>
          <AffiliateLinks
            tikiLink={postDetail.tikiLink}
            shopeeLink={postDetail.shopeeLink}
            lazadaLink={postDetail.lazadaLink}
            affiliateLink={postDetail.affiliateLink}
            affiliateLogo={postDetail.affiliateLogo}
            currentPrice={postDetail.currentPrice}
            discountRate={postDetail.discountRate}
            oldPrice={postDetail.oldPrice}
          />
          <div style={{ width: '100%', overflow: 'hidden' }}>{ReactHtmlParser(postDetail[postDetail.displayProperty])}</div>
          <AffiliateLinks
            atBottom
            tikiLink={postDetail.tikiLink}
            shopeeLink={postDetail.shopeeLink}
            lazadaLink={postDetail.lazadaLink}
            affiliateLink={postDetail.affiliateLink}
            affiliateLogo={postDetail.affiliateLogo}
            currentPrice={postDetail.currentPrice}
            discountRate={postDetail.discountRate}
            oldPrice={postDetail.oldPrice}
          />
          <div className="d-flex flex-direction-row align-items-center mt-3 mb-3">
            <b>Share:</b>
            <a
              href={`${facebookUriShare}${hostName}${pathname}`}
              className="ms-2"
              target="_blank"
              rel="noreferrer">
              <i className="fa fa-facebook bg-primary text-white p-2 rounded" aria-hidden="true"><b>acebook</b></i>
            </a>
            <a
              href={`${twitterUriShare}${hostName}${pathname}`}
              className="ms-2"
              target="_blank"
              rel="noreferrer">
              <i className="fa fa-twitter bg-primary text-white p-2 rounded" aria-hidden="true">&nbsp;<b>twitter</b></i>
            </a>
          </div>
          <div className="d-flex flex-direction-row align-items-center mt-3 mb-3">
            <b>Từ khoá:</b>
            <Link to={`/${postDetail.category}s`}>
              <span className="badge rounded-pill bg-secondary ms-2">{postDetail.category}</span>
            </Link>
            <Link to={`/search/type?value=${postDetail.type}`}>
              <span className="badge rounded-pill bg-secondary ms-2">{postDetail.type}</span>
            </Link>
          </div>
        </div>
        <div className="col-lg-4">
          <CategoryWrapper>
            <CategoryHeader
              left={
                <div>Bài đăng mới nhất</div>
              }
            />
            <CategoryBody itemPerRow={1}>
              {posts && posts.map(item => {
                const { _id, category, title, ...rest } = item;
                return (
                  <ProductHorizontal
                    key={_id}
                    isSideBar={true}
                    path={`/${category}s/${_id}`}
                    title={title}
                    {...rest}
                  />
                );
              })}
            </CategoryBody>
          </CategoryWrapper>
        </div>
      </div>
      {relatedPosts.length ?
        <div style={{ width: '99%', margin: 'auto' }}>
          <CategoryWrapper>
            <CategoryHeader
              left={
                <div>Bài đăng liên quan</div>
              }
            />
            <CategoryBody itemPerRow={2}>
              {relatedPosts && relatedPosts.map(item => {
                const { _id, category, title, ...rest } = item;
                return (
                  <ProductHorizontal
                    key={_id}
                    path={`/${category}s/${_id}`}
                    title={title}
                    {...rest}
                  />
                );
              })}
            </CategoryBody>
          </CategoryWrapper>
        </div> : null}
    </>
  )
}